module.exports = __webpack_public_path__ + "static/img/spoon.6bed68d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/spoon.png
// module id = 9Kvm
// module chunks = 0